import * as React from 'react'
import PropTypes from 'prop-types'
import cs from 'classnames'
import { Sheet } from '@paypalcorp/pp-react'
import styles from './interstitial.module.css'

const Interstitial = ({ isOpen, onClose, children }) => (
  <Sheet
    isOpen={isOpen}
    onClose={onClose}
    containerClassName={cs(styles.Interstitial, styles.Interstitial__Container)}
    hideTitle
  >
    {children}
  </Sheet>
)

Interstitial.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default Interstitial
